<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Award Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{ name: 'award-points' }">Award Points</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">

            <label class="card-title font-weight-bold">View Details</label>

            <br />
            <div class="row">
              <div class="col-3">
                <span style="font-weight: bold;">Event Name: </span>
                <br>
                <span>{{ event.name }}</span>
              </div>
              <div class="col-3">
                <span style="font-weight: bold;">Uploaded By: </span>
                <br>
                <span>{{ event.user.name }}</span>
              </div>
              <div class="col-2">
                <span style="font-weight: bold;">Remarks: </span>
                <br>
                <textarea class="form-control" v-if="checkUser" v-model="reject_remark"></textarea>
                <span v-else>{{ event.remarks }}</span>
              </div>
            </div>

            <br />

            <div class="row">
              <div class="col-3">
                <span style="font-weight: bold;">Description: </span>
                <br>
                <span>{{ event.description }}</span>
              </div>
              <div class="col-3">
                <span style="font-weight: bold;">Date Uploaded: </span>
                <br>
                <span>{{ event.created_at }}</span>
              </div>

            </div>
            <br />

            <div class="row">
              <div class="col-3">
                <span style="font-weight: bold;">Points Awarded: </span>
                <br>
                <span>{{ event.point }}</span>
              </div>
            </div>

            <div v-show="checkUser && event.status == 'Pending'" class="float-right">
              <button class="btn btn-success mr-1" style="width: 150px" data-toggle="modal"
                data-target=".event-approve-modal">
                Approve
              </button>
              <button type="button" class="btn btn-danger" style="width: 150px" data-toggle="modal"
                data-target=".event-reject-modal">
                Reject
              </button>
            </div>

            <div style="margin-top: 150px"></div>

            <hr />

            <h4>Selected Users</h4>
            <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
              <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
                {{ button.name }}
              </button>
            </div>

            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button type="button" class="btn btn-primary mr-1" @click="filterSearch">
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline mr-1">
                <input type="input" class="form-control" v-model="search" />
              </div>
            </div>

            <div class="table-responsive">
              <!-- All -->
              <table id="vendor_tbl" class="display table table-striped table-bordered"
                style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>IC Number</th>
                    <th>Mobile Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="users.length < 1">
                    <td colspan="3">No Data</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-for="(user, index) in users" :key="index">
                    <td>{{ user.name }}</td>
                    <td>{{ user.ic_number }}</td>
                    <td>{{ user.mobile_number }}</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-model="pageInfo.current_page" :per-page="pageInfo.per_page" :records="pageInfo.total"
                @paginate="handlePageChange" />
            </div>


            <div class="modal fade event-approve-modal" role="dialog" aria-labelledby="myLargeModalLabel"
              aria-hidden="true" id="event-approve-modal">
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="container py-4 px-4" style="text-align: center;">
                    <b>
                      <h4 style="text-align: center; color: #AC8400">Award Points to Selected User</h4>
                    </b>

                    <label style="text-align: center;">Are you sure you want to award {{ event.point }} points to the
                      selected user?</label>

                    <div style="text-align: center">
                      <button class="btn mr-1"
                        style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
                        @click="hideModal('#event-approve-modal')">
                        Cancel
                      </button>
                      <button class="btn"
                        style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
                        @click="onClick(1, '#event-approve-modal', `/loyalty/award/approval/multiple`)">
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal fade event-reject-modal" role="dialog" aria-labelledby="myLargeModalLabel"
              aria-hidden="true" id="event-reject-modal">
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="container py-4 px-4" style="text-align: center;">

                    <label style="text-align: center;">Are you sure you want to reject selected user?</label>

                    <br />

                    <div style="text-align: center">
                      <button class="btn mr-1"
                        style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
                        @click="hideModal('#event-reject-modal')">
                        close
                      </button>
                      <button class="btn"
                        style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
                        @click="onClick(0, '#event-reject-modal', `/loyalty/award/approval/multiple`)">
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import "vue-select/dist/vue-select.css";
import { getRequest, postRequest } from "@/services/RequestService";
import Pagination from "vue-pagination-2";

export default {
  name: "award-event-details",
  mixins: [dateManipulation],
  components: { Pagination },

  data() {
    return {
      users: [],
      event: {
        id: null,
        name: null,
        description: null,
        point: null,
        remarks: null,
        status: null,
        approver_id: null,
        approved_at: null,
        rejected_at: null,
        created_at: null,
        user: {
          id: null,
          name: null,
          ic_number: null,
          mobile_number: null
        },
        approver: {
          id: null,
          name: null
        },
        event_id: this.$route.params.event_id
      },
      event_id: this.$route.params.event_id,

      userApi: `${axios.lpsURL}/award/${this.$route.params.event_id}/multiple/selected_users`,

      signApi: '?',

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Awarded" },
        { status: false, name: "Not Awarded" }
      ],

      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      checkUser: false,
      reject_remark: null,
      search: null


    };
  },

  methods: {
    async loadDetails() {
      try {
        let res = await getRequest(`${axios.lpsURL}/award/${this.$route.params.event_id}/multiple`);
        this.event = res.data.success ? res.data.event
          :
          {
            id: null,
            name: null,
            description: null,
            point: null,
            remarks: null,
            status: null,
            approver_id: null,
            approved_at: null,
            rejected_at: null,
            created_at: null,
            user: {
              id: null,
              name: null,
              ic_number: null,
              mobile_number: null
            },
            approver: {
              id: null,
              name: null
            },
            event_id: this.$route.params.event_id
          };
          this.reject_remark = this.event.remarks;
      } catch (e) {
        console.log(e)
      }
    },


    async loadUser() {
      try {
        let res = await getRequest(this.userApi);
        this.users = res.data.success ? res.data.data.selected_users : [];
        this.pageInfo = res.data.data.pagination;


      } catch (e) {
        console.log(e)
      }
    },

    async handlePageChange(page) {
      try {
        let res = await getRequest(this.userApi + `${this.signApi}page=${page}`);

        this.users = res.data.data.selected_users;
        this.pageInfo = res.data.data.pagination;


      } catch (e) {
        console.log(e)
      }
    },

    async onPressBtn(int) {
      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      this.checkButtonStatus();
    },

    checkButtonStatus() {
      if (this.buttons[0].status) {
        this.signApi = '?';
        this.userApi = `${axios.lpsURL}/award/${this.$route.params.event_id}/multiple/selected_users`;
      } else if (this.buttons[1].status) {
        this.signApi = '&';
        this.userApi = `${axios.lpsURL}/award/${this.$route.params.event_id}/multiple/selected_users?type=1`;
      } else {
        this.signApi = '&';
        this.userApi = `${axios.lpsURL}/award/${this.$route.params.event_id}/multiple/selected_users?type=0`
      }
      this.loadUser()
    },

    async userCheckPrevy() {
      try {
        let res = await getRequest(`${axios.lpsURL}/award/check_permission`);
        this.checkUser = res.data.approver;
      } catch (e) {
        this.checkUser = false;
        console.log(e)
      }
    },

    async onClick(type, modal, url) {
      if(type == 0 && (this.reject_remark == null || this.reject_remark == '')) {
        return swal({
          title: "Failed",
          icon: "error",
          text: "Please enter your remarks."
        })
      }
      let formData = {
        _method: "PATCH",
        event_point_id: this.$route.params.event_id,
        approval_type: type,
        remarks: this.reject_remark
      }

      try {
        let res = await postRequest(url, formData);

        swal({
          title: res.data.success ? "Success" : "Failed",
          icon: res.data.success ? "success" : "error",
          text: res.data.message,
        });

        $(modal).modal('hide');

        if(res.data.success) {
          this.loadDetails();
          this.loadUser();
          this.reject_remark = null;
        }

      } catch (e) {
        console.log(e);
      }
    },

    async filterSearch() {
      try {
          let res = await getRequest(this.userApi +this.signApi+"search="+this.search);
  
          this.users = res.data.data.selected_users;
          this.pageInfo = res.data.data.pagination;

      } catch (e) {
        console.log(e)
      }
    },

    hideModal(name) {
      $(name).modal('hide');
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.loadDetails();
    await this.loadUser();
    await this.userCheckPrevy();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
